import callAPiBase from './base';

const supervisorsGroupsApi = {
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/supervisorGroupList',
      method: 'GET',
      useToken: true,
      title: 'Group - Get List',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/supervisorGroupCreate',
      method: 'POST',
      useToken: true,
      title: 'Group - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/supervisorGroupUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Group - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/supervisorGroupDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Group - Delete',
      params,
    }),
};

export { supervisorsGroupsApi };
export default supervisorsGroupsApi;
